import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCryptXWayExpandPresentation} from "../../presentations/maingame/TheCryptXWayExpandPresentation";
import {TheCryptNudgePresentation} from "../../presentations/maingame/TheCryptNudgePresentation";
import {TheCryptInitialWinPresentation} from "../../presentations/TheCryptInitialWinPresentation";
import {WinCountUpPresentation} from "../../presentations/WinCountUpPresentation";
import {TheCryptRoundEndPresentation} from "../../presentations/TheCryptRoundEndPresentation";
import {TheCryptBigWinPresentation} from "../../presentations/TheCryptBigWinPresentation";
import {FreespinOutroPresentation} from "../../presentations/freespin/FreespinOutroPresentation";
import {WinCapPresentation} from "../../presentations/WinCapPresentation";
import {FreeSpinNoWinPause} from "../../presentations/freespin/FreeSpinNoWinPause";

export class TheCryptFSWinPresentation implements FlowStatePresentation {

    private _presentations: SimplePresentation[];

    constructor() {
            this._presentations = [
                new TheCryptXWayExpandPresentation(),
                new TheCryptNudgePresentation(),
                new TheCryptInitialWinPresentation(),
                new WinCountUpPresentation(),
                new TheCryptRoundEndPresentation(),
                new TheCryptBigWinPresentation(),
                new FreespinOutroPresentation(),
                new WinCapPresentation(),
                new FreeSpinNoWinPause()
            ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}